import type { ShortfallNoteDto } from '@pams/shared';
import { shortfallGroups, shortfallSentence } from '@/lib/shortfallNote';

/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  [P7A §4] ONE DUTY'S SHORT-FALL NOTES, UNDER `Still to come` AND `Closed short` — the preview modal
 *  and the PA record page both render this, so the two cannot word a gap differently.
 *
 *  ⚠️ EXTRACTED VERBATIM FROM `ArrangementPreviewModal.tsx` ([C4a §7a], [amended C5b §3]). The record
 *  page fetched `duty.shortfalls` through the same `?view=preview` read and never rendered them, so a
 *  division that had already replied and one that could still be chased read alike there while the
 *  preview of the same order told them apart. The markup moved and did not change; the TEST ID is the
 *  host's, so the modal keeps `preview-shortfalls-<id>` and every assertion about it.
 *
 *  ⚠️ NOTHING AT ALL WHEN THERE IS NOTHING TO SAY — no heading over an empty list (§7d).
 * ─────────────────────────────────────────────────────────────────────────────────
 */
export const ShortfallNotes = ({ notes, testId }: { notes: readonly ShortfallNoteDto[]; testId: string }) =>
  notes.length === 0 ? null : (
    <div data-testid={testId} className="flex flex-col gap-1">
      {shortfallGroups(notes).map((group) => (
        <div key={group.heading}>
          <p className="text-xs font-medium text-foreground">{group.heading}</p>
          <ul className="flex list-disc flex-col gap-0.5 pl-4 text-xs text-muted-foreground">
            {group.notes.map((note) => (
              <li key={note.addresseeOrgUnitId}>{shortfallSentence(note)}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
